import UserProfile from '../../base/pages/userProfile';

const userProfile: UserProfile = {
  requestFailed: "Profile change has failed."
};

export default userProfile;
